module.exports = "/fonts/Objectivity-Regular.woff2";